<template>
  <div class="customer-wrap">

    <div class="house-tree" v-show="houseTreeVisable">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>

    <div class="body">
      <div class="options-bar">

      </div>
      <el-collapse v-model="searchActiveNames">
        <el-collapse-item title="查询条件" name="1">

          <div class="search-condition">
            <el-descriptions :column="2" size="mini" border>
              <el-descriptions-item label="房号" prop="room_name">
                <el-autocomplete size="mini"
                                 style="min-width: 400px;max-width: 100%"
                                 v-model="searchFrom.room_name"
                                 :fetch-suggestions="querySearchAsyncRoom"
                                 placeholder="请输入房产"
                                 popper-class="autocomplete-room"
                ></el-autocomplete>
                <el-button size="mini" type="primary" icon="el-icon-office-building" @click="showHouseTree()"></el-button>
              </el-descriptions-item>
              <el-descriptions-item label="">
                <el-button type="primary" size="mini" @click="search()" :loading="searchLoading">查询</el-button>
                <el-button size="mini" @click="resetForm('searchForm')">重置</el-button>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-collapse-item>
      </el-collapse>

      <div class="data-list mt-15">
        <el-link type="danger">更新数： {{pageTotal}} 条 </el-link>
        <el-table v-loading="searchLoading" :data="customerList" border style="width: calc(100vw - 200px)" ref="customerTable" :key="tableKey">
          <el-table-column prop="house_id" label="ID" width="70" fixed></el-table-column>
          <el-table-column prop="address" label="房产" align="center" fixed></el-table-column>
          <el-table-column prop="type_name" label="房产类型" width="150" align="center"></el-table-column>
          <el-table-column prop="status_name" label="房产状态" width="150" align="center"></el-table-column>
          <el-table-column prop="date" label="创建时间" width="150" align="center"></el-table-column>
          <el-table-column label="历史账单" width="100" align="center">
            <template slot-scope="scope">
              <span title="欠费账单/所有账单">{{scope.row.order_count}}/{{scope.row.all_order_count}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="$router.push({path: '/User/CustomerSale', query: {houseid: scope.row.house_id,housename: scope.row.address}})">售楼登记</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block pagination">
          <el-pagination background layout="prev, pager, next" :total="pageTotal" :page-size="pageSize" :current-page="page" @current-change="changePage"></el-pagination>
        </div>
      </div>
      <!-- 编辑器 -->
      <editor v-model="visable" :classValue="classValue" :id="id" @callback="callback(arguments)"></editor>

      <ShowXscCustomer ref="showXscCustomerRef" />
      <SelectCustomerHouseStatus ref="selectCustomerHouseStatusRef" />

    </div>

  </div>
</template>

<script>

import Common from './common.js'
import moment from "moment";
import Http from "./common/Http";
import ShowXscCustomer from "./components/ShowXscCustomer";
import SelectCustomerHouseStatus from "./components/SelectCustomerHouseStatus";

export default {
  name: "CustomerBinding",
  data(){
    return{
      searchFrom: {
        name: '',
        room_name: '',
        room_id: 0
      },
      customerList: [],
      id: 0,
      visable: false,
      classValue: 0,
      pageTotal: 0,
      pageSize: 10,
      page: 1,
      houseTreeVisable: false,
      tableKey: 1,
      searchLoading: false,
      searchActiveNames:"1",
    }
  },
  components: {
    SelectCustomerHouseStatus,
    ShowXscCustomer,
    'editor': () => import('./editor.vue'),
    'erp-tree-status': () => import('../Common/erp-tree-status.vue'),
  },
  mounted() {
    this.getList();
  },
  watch: {
    page(val) {
      this.getList()
    },
    'searchFrom.room_name'(val) {
      if(val == '') {
        this.searchFrom.room_id = 0
      }
    }
  },
  methods: {
    getList() {
      this.searchLoading = true
      let params = Object.assign({page: this.page, pageSize: this.pageSize}, this.searchFrom)
      this.$myhttp.get('admin/Customer/getCustomerBinding', {params: params}).then(backdata => {
        let res = backdata.data
        if(res.code == 200) {
          this.customerList = res.data.data
          this.pageTotal = res.data.total
        } else {
          this.$message.error('获取客户列表出错！');
        }
        this.searchLoading = false
      })
    },
    timeFormat: Common.timeFormat,
    getClassName: Common.getClassName,
    getTypeNames(val) {
      if(!val){
        return ''
      }
      let arr = Common.getTypeNames(val)
      return arr.join(', ')
    },

    changePage(i) {
      this.page = i
    },
    search() {
      this.page = 1
      this.getList()
    },
    showEditor(_class, id) {
      this.classValue = _class
      this.id = id
      this.visable = true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    callback(arg) {
      this.getList()
      if(arg && arg[0]) this.id = arg[0]
    },
    nodeClick(data){
      if(data.tree[data.tree.length-1].type==='room'){
        this.searchFrom.room_id = data.id
      }
      let room_name = []
      data.tree.forEach(item => {
        room_name.push(item.name)
      })
      this.searchFrom.room_name = room_name.join('->')
    },
    showHouseTree() {
      this.houseTreeVisable = !this.houseTreeVisable;
      this.tableKey += 1
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped="scoped">

@import "./common.scss";

.pagination {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

.customer-wrap {
  display: flex;
  position: relative;

  .body {
    flex: 1;
  }
}

.data-list {
  overflow: auto;
}

.autocomplete-room{
  width: 500px;
}

.search-wrap{
  width: calc(100vw - 200px);
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/customer_binding.vue